import { Outlet } from 'react-router-dom';
import MainHeader from './header';
import { Avatar, Box, Button, Card, CardContent, Dialog, Drawer, Input, Menu, MenuItem, Select, Tabs, Typography } from '@mui/material';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { get, post, postImage } from 'api/apiBridges/httpBridge';
import { useDispatch, useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import { Email, Margin } from '@mui/icons-material';
import Loading from 'components/Load';
import { enqueueSnackbar } from 'notistack';
import { SocketContext } from 'components/socketLib/ConnectorSocket';
import { colors } from 'styles/colors';
import { onChangeUploadImage } from 'store/slices/uploadImage';
import useOn from 'components/socketLib/UseOn';
import EditIcon from '@mui/icons-material/Edit';
import UserAvatar from "../components/EIComponents/UserAvatar";
import { useLocalNotifications } from 'components/Events';
import { ReportTable } from 'components/reportTable';
import { getDataSource } from 'api/ds';
import Scrollbars from 'rc-scrollbars';
import { SelectMarketLocal } from 'components/SelectMarket';
import { DealTab, StyledTab } from 'utils/formatters';
import { TabPanel } from 'components/tabPanel';
import { ElementInfo } from 'components/ElementInfo';
import ClassicSearch from 'components/classicSearch';
import MoveGuideDialog from 'components/MoveGuideDialog';
import usePreventDoubleClick from 'components/AntiDBC';
import { CancelButton, OKButton } from 'components/EIComponents/LittleComponents';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { hoverStyle } from 'styles/main';
import handleConfirm from 'components/AlertMessage';

const FBSAdminNew = ({setSearch, setInfo, setButtons}) => {

  const TESTMODE = false

  const { company_id, user_id } = useSelector(
      loginSelector
  );
  const [market, setMarket] = useState(localStorage.getItem("FBSMARKET") || "wb");
  const ds = useMemo(() => market === 'wb'? getDataSource('fbsAdminWB'): market === 'ozon'? getDataSource('fbsAdminOZON'): getDataSource('fbsAdmin'), [market]);

  const [loading, setLoading] = useState(true);
  /** @type {[Array<any>, Function]} */
  const [data, setData] = useState([])
  /** @type {[Array<any>, Function]} */
  const [clis, setClis] = useState([])
  /** @type {[Array<any>, Function]} */
  const [selected, setSelected] = useState([])
  /** @type {[any, Function]} */
  const [selectedCLI, setSelectedCLI] = useState(undefined)
  

  // const { socket } = useContext(SocketContext);
  const [anchorSettings, setAnchorSettings] = useState(false);// якорь для  меню настроек
  const [loadingMenu, setLoadingMenu] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  /** @type {[Array<any>, Function]} */
  const [openDeals, setOpenDeals] = useState([]);
  const dispatch = useDispatch();
  const onSubmit = useCallback((data) => {
      dispatch(onChangeUploadImage(data));
  }, [dispatch]);

  const { showNotification } = useLocalNotifications();
  const preventDoubleClick = usePreventDoubleClick();

  const [checked, setChecked] = useState(false);
  /** @type {[any, Function]} */
  const [filter, setFilter] = useState(null);
  /** @type {[any, Function]} */
  const [filterFields, setFilterFields] = useState({});

  useEffect(() => {
      switch (market) {
        case "wb":{
          setFilterFields(
            {
                cli_id: {name: "ID клиента", active: true},
                cli_name: {name: "Имя клиента", active: true},
                product: {name: "Товар", active: true},
                barcode: {name: "Баркод", active: true},
                whwb: {name: "Склад WB", active: true},
                whcli: {name: "Склад продавца", active: true},
            }
          )
          break
        }
        case "ozon":{
          setFilterFields(
            {
                cli_id: {name: "ID клиента", active: true},
                cli_name: {name: "Имя клиента", active: true},
                product: {name: "Товар", active: true},
                barcode: {name: "Баркод", active: true},
            }
          )
          break
        }
      }
  }, [market]);

  useEffect(() => {
      const getInfo = () => {
          return (
              <>
                  <Typography sx={{ 
                    fontSize: '12pt',  
                    margin: '5px 15px 5px 10px'
                  }}>
                    Количество заказов: {data.filter((fel) => selectedCLI? fel.user.user_id === selectedCLI.id: true).length}
                  </Typography>
                  <Typography sx={{ fontSize: '12pt', margin: '5px 15px 5px 0px'  }}>
                    Выбрано: {selected.length} шт.
                  </Typography>
              </>
          )
      }
      setInfo(getInfo())
  }, [data, selected, selectedCLI]);

  useEffect(() => {
      const getButtons = () => {
          return (
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>
              <Button
                onClick={preventDoubleClick(openMenuSettigs, 1000)}
                variant="contained"
                size="medium"
                sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    width: '150px'
                }}
                disabled={createLoading || selected.length === 0}
              >
                Собрать
              </Button>
              {createLoading && <Loading/>}
              <SelectMarketLocal markets={['wb', 'ozon']} market={market} save={(m) => {localStorage.setItem("FBSMARKET", m); setMarket(m)}} size={30}></SelectMarketLocal>
            </div>
          )
      }
      setButtons(getButtons())
  }, [market, selected, createLoading]);

  useEffect(() => {
      const getSearch = () => {
          console.log("FFFF selectedCLI", selectedCLI)
          return (
              <>
                <ClassicSearch 
                  setChecked={setChecked} 
                  setFilter={setFilter} 
                  checked={checked} 
                  // @ts-ignore
                  fields={filterFields} 
                  // @ts-ignore
                  setFields={setFilterFields}
                />
                <Select
                  key={market}
                  displayEmpty
                  value={selectedCLI}
                  onChange={(e) => {
                    setSelectedCLI(e.target.value);
                  }}
                  sx={{
                      borderRadius: "10px", 
                      height: "30px", 
                      width: "20%",
                      backgroundColor: '#F5F9FA',
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none'
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        border: 'none'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: 'none'
                      }
    
                  }}
                  MenuProps={{
                      PaperProps: {
                          sx: {
                              maxHeight: "400px",      // ограничение по высоте
                              overflowY: 'auto'    // включить прокрутку
                          }
                      }
                  }}
                  renderValue={(selectedValue) => {
                      console.log("RENDER VALUE", selectedValue);
                      if (!selectedValue) {
                          return (
                            <Typography variant="body1" sx={{ ml: 1}}>
                              {`Все`}
                            </Typography>
                          )
                      }
                      return (
                          <Typography variant="body1" sx={{ ml: 1}}>
                            {`${selectedValue.id} - ${selectedValue.fio}`}
                          </Typography>
                      )
                  }}
              >
                  <MenuItem key={'all'} value={undefined} style={{ borderRadius: '10px', marginBottom: '5px' }}>
                      <Typography variant="body1" sx={{ ml: 1}}>
                        {`Все`}
                      </Typography>
                  </MenuItem> 
                  {clis.map(sel => 
                      <MenuItem key={sel} value={sel} style={{ borderRadius: '10px', marginBottom: '5px' }}>
                          <Typography variant="body1" sx={{ ml: 1}}>
                            {`${sel.id} - ${sel.fio}`}
                          </Typography>
                      </MenuItem> 
                  )}
              </Select>
              </>
          )
      }
      setSearch(getSearch())
  }, [checked, filterFields, setFilter, setChecked, data, selectedCLI, clis]);

  useEffect(() => {
    const fetchData = async () => {
        try {
          setLoading(true);
          //Это данные по доступным fbs
          let resp = undefined
          switch (market) {
            case 'wb':
              resp = await get("WBAPI/getNewFBSWBOnCompany", {cid:company_id})
              break
            case 'ozon':
              resp = await get("OZONAPI/getNewFBSOzonOnCompany", {cid:company_id})
              break
          }


          if (Array.isArray(resp)) {
            resp.map((el) => {
              el.shortUser = `${el.user.user_id} - ${el.user.fio}`
              el.data.sizeTitle = el.data.size.title
              el.data.barcode = el.data.size.barcode
            })
            let tmpclis = []
            for (let el of resp) {
              if (!tmpclis.find((fel) => fel.id === el.user.user_id)) {
                tmpclis.push({id: el.user.user_id, fio: el.user.fio})
              }
            }
            console.log("tmpclis", tmpclis)
            setClis(tmpclis)
            setData(resp.sort((a, b) => 
              new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
            ))
          }
          else {
            setData([])
          }
          


        } catch (err) {
        } finally {
          setLoading(false);
        }
    };

    setClis([])
    setSelectedCLI(undefined)
    fetchData();
  }, [market]); 

  const create = async (selectedDeal = undefined) => {
    setOpenDeals([])
    setCreateLoading(true)
    let tmp = JSON.parse(JSON.stringify(data)).filter((fel) => selected.includes(fel.id))
    
    if (tmp.length < 1) {
        showNotification({
            id: 'NoSelTask', 
            type: 'error', 
            message: 'Ни один заказ не выбран' 
        });
        setCreateLoading(false)
        return 
    }

    if (market == 'ozon') {
      let groups = tmp.filter((fel) => fel.group > 1) 
      console.log("groups", groups)
      let groupCheck = {}
      for (let gel of groups) {
        if (groupCheck[gel.posting_number]) {
          groupCheck[gel.posting_number].count +=1
        }
        else {
          groupCheck[gel.posting_number] = {need: gel.group, count: 1}
        }
      }
      for (let k of Object.keys(groupCheck)) {
        if (groupCheck[k].need !== groupCheck[k].count) {
          showNotification({
            id: 'NOTZ', 
            type: 'warning', 
            message: `Для заказа ${k} выбраны не все товары` 
          });
          setCreateLoading(false)
          return 
        }
      }
    }

    let moveProducts = []
    
    const $data = [];
    let err = undefined
    let units = 0
    let users = []
    
    for (const el of tmp) {
      // Собираем объект товара
      const item = { nmID: el.nmID || el.data.size.nmID, countProduct: el.count || 1, ...el.data, size: el.data.size};
      delete item.size.countQr
      let tz = undefined
      console.log("item.size.", item.size)
      if (item.size.techTask?.versions) {
        let tzkeys = Object.keys(item.size.techTask?.versions)
        for (let tzk of tzkeys) {
          if (item.size.techTask?.versions[tzk].fbs) {
            tz = {
              text:item.size.techTask?.versions?.[tzk]?.text || undefined,
              services:item.size.techTask?.versions?.[tzk]?.services || undefined,
              print:item.size.techTask?.versions?.[tzk]?.print || undefined,
              version: tzk
            }
            break
          }
        }
      }
      if (!tz) {
          err = item.size.barcode
          break
      }

      delete item.size.techTask
      item.size.techTask = tz
      units += parseInt(item.countProduct);
      let idx = $data.findIndex((fel) => fel.nmID === item.nmID && fel.size.barcode === item.size.barcode)
      if (idx > -1) {
        $data[idx].countProduct += item.countProduct
      }
      else {
        $data.push({...item, countEtimated: 0});
      }
      if (!users.includes(el.user.user_id)) {users.push(el.user.user_id)}
    }

    if (err) {
        showNotification({
            id: 'NOTZ', 
            type: 'error', 
            message: `У товара ${err} не указано техническое задание для FBS` 
        });
        setCreateLoading(false)
        return 
    }
    if (users.length != 1) {
        showNotification({
            id: 'NOTZ', 
            type: 'error', 
            message: 'Выбраны поставки нескольких клиентов' 
        });
        setCreateLoading(false)
        return 
    }

    //Тут уже данные по хранению 
    const dist = await get('Deal/GetCliStorageProductsGroupBarcodes', {cid:users[0], market});   
    let AvConsumes = await get('Deal/getAvConsumesCounts', {cid:users[0]})
    
    ///собираем дейсвительный порядок распределения с учетом комплектации
    let resList = []
    let tmpdata = JSON.parse(JSON.stringify($data))//Делается для того, чтобы не испортить реальные данные временными изменениями
  

    //Собираем как будто есть толкьо товар на хранении

    // tmpdata.map((pr) => {
    for (let pr of tmpdata) {
      let count = pr.countProduct
      if (dist[pr.size.barcode]) {
        let dkeys = Object.keys(dist[pr.size.barcode])
          .filter((fel) => fel !== 'total')
          .sort((a, b) => {
            // Сравниваем prioritet_weight (чем больше, тем выше приоритет)
            const weightDiff = dist[pr.size.barcode][b].prioritet_weight - dist[pr.size.barcode][a].prioritet_weight;
            if (weightDiff !== 0) return weightDiff;
            // При равенстве веса сравниваем deal_id (по возрастанию)
            return dist[pr.size.barcode][a].deal_id - dist[pr.size.barcode][b].deal_id;
        });

        let c = 0
        while (count>0 && c<dkeys.length) {
          let tdist = dist[pr.size.barcode][dkeys[c]]
          let ncp = tdist.countProduct//Количество в конкретной сделке
          if (count > ncp) {
            count -= ncp
            ncp = 0
          }
          else {
            ncp -= count
            count = 0
          }
          console.log("pr.data", pr.data)
          resList.push(
            {
              user_id: users[0],
              nmID:pr.nmID, 
              deal_id:dkeys[c],
              barcode:pr.size.barcode,
              countProduct:ncp,
              prioritet_weight: tdist.prioritet_weight,
              tzServices: pr.size.techTask.services,
              addit: {
                size:pr.size,
                color:pr.color,
                vendorCode: pr.vendorCode,
                data: {title:pr.title, photo: pr.photo}
              }
            }
          )
          c+=1
        }
        pr.countProduct = count
      }
    }

    console.log("AV0", JSON.parse(JSON.stringify(AvConsumes)))
    //Теперь надо добить те товары, у которых еще осталось недобитое количесто новой комплектацией
    // tmpdata.map((pr) => {
    for (let pr of tmpdata) {
      let count = pr.countProduct
      console.log("pr", pr)
      moveProducts.push(
          {
              deal:0,
              count, 
              product:{
                  nmID: pr.nmID, 
                  size: pr.size,
                  color: pr.color,
                  vendorCode: pr.vendorCode,
                  data: {title:pr.title, photo: pr.photo}
              }
          }
      )
      if (count > 0) {
        if (pr.size.techTask.services) {
          let idx = pr.size.techTask.services.findIndex((fel) => fel.name === 'Комплектация товара')
          if (idx > -1) {
            ///Получаем список расходников, которые нужны
            let tmpErr = false
            //проверям, что количества достаточно
            pr.size.techTask.services[idx].data.consumes.map((cons) => {
              if (!AvConsumes[`cons${cons.id}`] || AvConsumes[`cons${cons.id}`] < count * cons.count) {
                tmpErr = true
              }
            })
            //Если хватает, чтобы добить товар, то вычитаем из расходников
            if (!tmpErr) {
              pr.size.techTask.services[idx].data.consumes.map((cons) => {AvConsumes[`cons${cons.id}`] -= count * cons.count})
              //Говорим, что товара достаточно
              pr.countProduct = 0 
            }
            
          }
        }
      }
    }

    console.log("AV1", JSON.parse(JSON.stringify(AvConsumes)))

    //Проверяем, что все товары добиты
    for (let pr of tmpdata) {
      if (pr.countProduct > 0) {
        showNotification({
            id: 'little_count', 
            type: 'error', 
            message: `На складе недостаточно товара ${pr.size.barcode}`
        });
        setCreateLoading(false)
        return
      }
    }

    console.log("AV2", JSON.parse(JSON.stringify(AvConsumes)))
    ////Отключил эту механику, так как рашели не брать товары с хранения с другим тз
    // //Соответнно, если функция не завершилась, значит можно перераспределить приоритеты
    // const minPrior = 2
    // // resList.map((el) => {
    // for (let el of resList){
    //   if (el.prioritet_weight < minPrior) {
    //     if (el.tzServices) {
    //       let idx = el.tzServices.findIndex((fel) => fel.name === 'Комплектация товара')
    //       if (idx > -1) {
    //         ///Получаем список расходников, которые нужны
    //         let tmpErr = false
    //         //проверям, что количества достаточно
    //         el.tzServices[idx].data.consumes.map((cons) => {
    //           if (!AvConsumes[`cons${cons.id}`] || AvConsumes[`cons${cons.id}`] < cons.count) {
    //             tmpErr = true
    //           }
    //         })
    //         //Если хватает, чтобы добить товар, то вычитаем из расходников
    //         if (!tmpErr) {
    //           el.tzServices[idx].data.consumes.map((cons) => {AvConsumes[`cons${cons.id}`] -= cons.count})
    //           // @ts-ignore
    //           el.del = true 
    //         }
    //       }
    //     }
    //   }
    // }
    // console.log("AV3", JSON.parse(JSON.stringify(AvConsumes)))

    // resList = resList.filter((fel) => !fel.del)

    let dealsNeedUpdate = []

    await Promise.all(resList.map(async (el) => {
      console.log("el.addit", el.addit)
      let res = await post("Deal/updateOnNmAndSizeNoChangeHist", {
        user_id: el.user_id,
        nmID: el.nmID, 
        deal_id: el.deal_id,
        barcode:el.barcode,
        countProduct: el.countProduct,
      })
      for (let fb of res.fromBoxes) {
        moveProducts.push(
            {
                deal:el.deal_id,
                box:fb.box, 
                count:fb.count, 
                product:{
                    nmID: el.nmID, 
                    size: el.addit.size,
                    color: el.addit.color,
                    vendorCode: el.addit.vendorCode,
                    data: el.addit.data
                }
            }
        )
      }
      if (!dealsNeedUpdate.includes(Number(el.deal_id))) {dealsNeedUpdate.push(Number(el.deal_id))}
    }))

   

    await Promise.all(dealsNeedUpdate.map(async (did) => {
      await post("Deal/recalcProducts", {did})
    }))

    //Пойдет в сделку
    let fbsdata = {}

    let oldDeal = undefined
    if (selectedDeal) {
      let resp = await get("Deal/get", {did: selectedDeal})
      oldDeal = resp.message
      oldDeal.data = JSON.parse(oldDeal.data)
      console.log(oldDeal)
    }

    //Методы для маркетов
    switch (market) {
      case "wb": {
        ////ОБЯЗЯТЕЛЬНО КОММНЕТИТЬ ЭТИ МЕТОДЫ ВО ВРЕМЯ ТЕСТОВ
        let supply_id = undefined
        if (oldDeal) {
          supply_id = oldDeal.data.fbsdata.supply_id
        }
        else {
          //FBS_COM
          if (!TESTMODE) {
            let today = new Date();
            let dateStr = today.toLocaleDateString('ru-RU');// ДД.ММ.ГГГГ

            let create_supply = await post("WBAPI/createNewSupply", {uid: users[0], name: `Поставка от ${dateStr}`})
            supply_id = create_supply.supply_id
          }
          else {
            supply_id = ''//'WB-GI-228812014'
          }
        }
        //FBS_COM
        if (!TESTMODE) {
          await post("WBAPI/addProductsToSupply", {uid: users[0], supply_id, cid:company_id, list:selected})
        }
        fbsdata.supply_id = supply_id
        fbsdata.list = selected
        console.log("SELECTED", selected)
        fbsdata.order_barcodes = selected.map((s) => {return {order: s, barcode: data.find((fel) => fel.id === s).data.size.barcode}})
        fbsdata.qrList = {}
        break
      }
      case "ozon": {

        let reqList = []

        tmp.map((el) => {
          reqList.push({
            posting_number: el.posting_number, //номер изначальной поставки
            product_id: el.data.size.ozonID, //id товара
            quantity: el.count, //Количество
            group: el.group, //Количество sku в заказе
            barcode: el.data.size.barcode,
          })
        })

        console.log("reqList", reqList)
        
        //Перенесим в статсу ожидает отгрузки
        ////ОБЯЗЯТЕЛЬНО КОММНЕТИТЬ ЭТИ МЕТОДЫ ВО ВРЕМЯ ТЕСТОВ
        //FBS_COM
        let resultList = []
        let posting_barcode = []
        if (!TESTMODE) {
          let resp = await post("OZONAPI/to_awaiting_delivery", {uid: users[0], reqList})
          for (let el of resp.result) {
            posting_barcode.push(el)
            resultList.push(el.posting)
          }
        }
        
        // posting_barcode.push({posting: el.posting_number, barcode: el.data.size.barcode})
        //Собираем данные для сделки
        fbsdata.list = resultList 
        fbsdata.posting_barcode = posting_barcode
        break
      }
    }
    if (oldDeal) {
      await post("Deal/addProductsToDeal", {list: $data, deal_id:selectedDeal, replace: false})
      await post("Deal/addToMoveGuide", {list:moveProducts.filter((fel) => fel.count > 0), id:selectedDeal})
      switch (market) {
        case "wb": {
          fbsdata.list = oldDeal.data.fbsdata.list.concat(fbsdata.list)
          fbsdata.order_barcodes = oldDeal.data.fbsdata.order_barcodes.concat(fbsdata.order_barcodes)
          await post("Deal/update",  {id: selectedDeal, data: {fbsdata}})
          break
        }
        case "ozon": {
          fbsdata.list = oldDeal.data.fbsdata.list.concat(fbsdata.list)
          fbsdata.posting_barcode = oldDeal.data.fbsdata.posting_barcode.concat(fbsdata.posting_barcode)
          //Запускает задачу на получение баркодов, так как они генерируются в течении нескольких минут
          ////ОБЯЗЯТЕЛЬНО КОММНЕТИТЬ ЭТИ МЕТОДЫ ВО ВРЕМЯ ТЕСТОВ
          //FBS_COM
          if (!TESTMODE) {
            post("OZONAPI/startWaitBCTask", {uid: users[0], deal_id: oldDeal.id})
          }
          await post("Deal/update",  {id: selectedDeal, data: {fbsdata}})
          break
        }
      }
      tmp = JSON.parse(JSON.stringify(data)).filter((fel) => !selected.includes(fel.id))
      setData(tmp)
      setSelected([])
      showNotification({
          id: 'addtoDealSuccess', 
          type: 'success', 
          message: 'Товар успешно добавлен' 
      });
    }
    else {
      //Запрашиваем клиента
      const cli = await get('Clients/get', {cid:users[0]});
      let sku = $data.length;
      //Создаем сделку
      fbsdata.date = new Date().toLocaleDateString('ru-RU')
      let nd = await post('Deal/create', 
        {
            products: $data, 
            count_bale: 1,//? 
            warehouse_tranzit: "", //?
            warehouse_market: "", //?
            date_shipment: new Date(), //?
            id_company: company_id, 
            id_client: users[0], 
            id_manager: Number(cli.message.manager_id), 
            market: market, 
            number_order: "", 
            status: 1, 
            type: "moving_deals",
            move_guide: moveProducts,
            data:{
                    sku,
                    units,
                    end_date:new Date(),//?
                    fbs: true,
                    fbsdata
                }
        })
      if (nd?.id) {
        console.log("fbsdata", fbsdata)
          //Лог о содании сделки
          await post("Logs/create", {
              deal_id:nd.id,
              user_type:"ful",
              user_id,
              type: "create_deal",
              data: {
                  sku,
                  units,
              }
          })
          // socket.emit('add_new_deal', {company_id, type: "moving_deals", id:nd.id});

          ////ОБЯЗЯТЕЛЬНО КОММНЕТИТЬ ЭТИ МЕТОДЫ ВО ВРЕМЯ ТЕСТОВ
          //Тут опять действия с маркетами, но для которых уже нужно знать сделку
          switch (market) {
            case "wb": {
              //Для вб как выяснилось ничего не нужно
              break
            }
            case "ozon": {
              //Запускает задачу на получение баркодов, так как они генерируются в течении нескольких минут
              ////ОБЯЗЯТЕЛЬНО КОММНЕТИТЬ ЭТИ МЕТОДЫ ВО ВРЕМЯ ТЕСТОВ
              //FBS_COM
              if (!TESTMODE) {
                post("OZONAPI/startWaitBCTask", {uid: users[0], list:fbsdata.list, deal_id: nd.id})
              }
              break
            }
          }

          tmp = JSON.parse(JSON.stringify(data)).filter((fel) => !selected.includes(fel.id))
          setData(tmp)
          setSelected([])
          showNotification({
              id: 'createDealSuccess', 
              type: 'success', 
              message: 'Сделка усспешно создана' 
          });

      }
      else {
          showNotification({
              id: 'createDealErr', 
              type: 'error', 
              message: 'Ошибка при создании сделки, сообщите администратору' 
          });
      }
    }
    setCreateLoading(false)
  }

  const openSettings = Boolean(anchorSettings);// открыт ли Popover настроек
  //Функции для открытия и закрытия настроек
  const openMenuSettigs = async (event) => {
    setLoadingMenu(true)
    let tmp = JSON.parse(JSON.stringify(data)).filter((fel) => selected.includes(fel.id))
    
    if (tmp.length < 1) {
        showNotification({
            id: 'NoSelTask', 
            type: 'error', 
            message: 'Ни один заказ не выбран' 
        });
        setLoadingMenu(false)
        return 
    }
    
    let users = []
    
    for (const el of tmp) {
      if (!users.includes(el.user.user_id)) {users.push(el.user.user_id)}
    }

    if (users.length != 1) {
        showNotification({
            id: 'NOTZ', 
            type: 'error', 
            message: 'Выбраны поставки нескольких клиентов' 
        });
        setLoadingMenu(false)
        return 
    }

    let resp = await get("Deal/getOpenFbsDealOnCli", {uid: users[0], market})

    setOpenDeals([{id: -1, cdn: "Новая", products: []}, ...resp])

    setLoadingMenu(false)

  }
  
  console.log("openDeals", openDeals)
  console.log("openSettings", openSettings)
  console.log("anchorSetiings", anchorSettings)
  console.log("SelectedCli", selectedCLI)


  return (
    <div style={{display: 'flex', flexDirection: 'column', justifyContent:'flex-start', width: '100%', height: '100%', overflow: 'hidden' }}>
      <Dialog
          open={openDeals.length > 0}
          maxWidth={false}
          PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
          onClose={() => { setOpenDeals([]) }}
      >
          <div style={{ height: '620px', width: '600px', padding: '12px' }}>
              <AddProductsFBS cancel={() => setOpenDeals([])} data={openDeals} addToDeal={(did) => {create(did)}}/>
          </div>
      </Dialog>
      <div style={{
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent:'flex-start', 
          width: '98%', 
          height: "calc(94% - 55px )", 
          overflow: 'hidden',
          margin: "0% 1% 1% 1%",
          borderRadius: "10px",
          borderTopLeftRadius: '0px',
          backgroundColor: 'white'
      }}>
        {loading? 
          <Loading></Loading>
        :
          <Scrollbars
            autoHeight
            autoHeightMax={"100%"}
            style={{ width: '100%', borderRadius: "10px" }} 
            >
              <ReportTable
                ds={ds}
                data={!checked ? data.filter((fel) => selectedCLI? fel.user.user_id === selectedCLI.id: true) : data.filter((fel) => selectedCLI? fel.user.user_id === selectedCLI.id: true).filter((el) => {
                    const tf = filter.toLowerCase(); 
                    return (
                        
                        (filterFields.cli_id?.active && el.user.user_id && String(el.user.user_id).toLowerCase().includes(tf)) || 
                        (filterFields.cli_name?.active && el.user.fio && String(el.user.fio).toLowerCase().includes(tf)) || 
                        (filterFields.barcode?.active && el.data.size.barcode && String(el.data.size.barcode).toLowerCase().includes(tf)) ||
                        (filterFields.product?.active && el.data.title && String(el.data.title).toLowerCase().includes(tf)) ||
                        (filterFields.whwb?.active && el.warehouseWB?.name && el.warehouseWB.name.toLowerCase().includes(tf)) ||
                        (filterFields.whcli?.active && el.warehouseCLI?.name && el.warehouseCLI.name.toLowerCase().includes(tf))
                        
                    );
                })}    
                onSelect={(s) => {setSelected(s)}}
                inputSelected={selected}
                autoPagination={15}
                customNoDataText={"Нет новых заказов"}
              />               
          </Scrollbars>
        }
        
      </div>
    </div>  
  );
};

function AddProductsFBS({ cancel, data, addToDeal }) {
    /** @type {[any, Function]} */
    const [selected, setDeal] = useState(undefined);

    const preventDoubleClick = usePreventDoubleClick();

    console.log("data", data)

    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div style={{ height: '92%', display: 'flex', flexDirection: 'row', width: "98%", margin: "1%", justifyContent: 'space-between'}}>
            <Scrollbars
                style={{ width: '49%', height: '100%'}} 
            > 
              {data.map((deal) => 
                <Card
                  sx={{
                      width: '96%',
                      backgroundColor: 'white',
                      borderRadius: "10px",
                      cursor: 'pointer',
                      transition: 'background-color 0.2s ease',
                      borderStyle: "solid",
                      borderWidth: (selected && selected === deal.id) || (!selected && deal.id === -1)? "2px": '0px',
                      borderColor: "#078476",
                      '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.12)', // затемнение при наведении
                      },
                      marginBottom: "5px"
                  }}
                  onClick={() => {if (deal.id !== -1) setDeal(deal.id); else setDeal(undefined);}}
                >
                  <CardContent
                      sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      p: '8px 16px',       // компактные отступы
                      '&:last-child': { pb: '8px' },
                      }}
                  >
                      <div style={{width: '100%'}}>
                          <Typography sx={{ fontWeight: 'normal', fontSize: '12pt' }}>
                               {`${deal.id !== -1? "Сделка - ": ""}${deal.cdn}`}
                          </Typography>
                      </div>
                  </CardContent>
              </Card>
              )}
            </Scrollbars>
            <Scrollbars
                style={{ width: '49%', height: '100%'}} 
            > 
              {(selected? data.find((fel) =>  fel.id === selected)?.products || [] : []).map((pr) => 
                <Card
                  sx={{
                      width: '98%',
                      backgroundColor: 'white',
                      borderRadius: "10px",
                      cursor: 'pointer',
                      transition: 'background-color 0.2s ease',
                      mb: "5px"
                  }}
                >
                  <CardContent
                      sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      p: '8px 16px',       // компактные отступы
                      '&:last-child': { pb: '8px' },
                      }}
                  >
                      <div style={{width: 'calc( 100% - 40px)'}}>
                          <Typography sx={{ fontWeight: 'normal', fontSize: '12pt' }}>
                               {`${pr.barcode} - ${pr.count}`}
                          </Typography>
                      </div>
                  </CardContent>
              </Card>
              )}
            </Scrollbars>
        </div>
        <Box
            sx={{
                display: "flex",
                gap: 2,
                height: "8%",
                width: "100%",
                justifyContent: 'space-between',
                alignItems: 'flex-end'
            }}
        >
        
            <CancelButton action={cancel} text={"ЗАКРЫТЬ"}/>
            <OKButton action={preventDoubleClick(() => addToDeal(selected),1000)} text={selected? "ДОБАВИТЬ": "СОЗДАТЬ"} />
            
        </Box>
    </div>
    )
}

const FBSAdminOpen = ({setSearch, setInfo, setButtons}) => {

  const { company_id, user_id } = useSelector(
      loginSelector
  );

  const [market, setMarket] = useState(localStorage.getItem("FBSMARKET") || "wb");

  const ds = useMemo(() => {
      let keyword = 'fbsAdminOpen'
      if(market === 'wb') {
        keyword = 'fbsAdminOpenWB'
      }
      const $ds = getDataSource(keyword); 
      $ds.descr.showDetails = (obj) => {
          console.log(obj);
          setSelDeal(obj.id)
      };
      return $ds;
  }, [market]);

  /** @type {[any, Function]} */
  const [clickedRow, setClickedRow] = useState(undefined);
  

  const [loading, setLoading] = useState(true);
  /** @type {[Array<any>, Function]} */
  const [data, setData] = useState([])
  const [selDeal, setSelDeal] = useState(undefined)

  const [checked, setChecked] = useState(false);
  /** @type {[any, Function]} */
  const [filter, setFilter] = useState(null);
  const [filterFields, setFilterFields] = useState(
      {
          cdn: {name: "Номер сделки", active: true},
          cli_id: {name: "ID клиента", active: true},
          cli_name: {name: "Имя клиента", active: true},
          product: {name: "Товар", active: true},
          barcode: {name: "Баркод", active: true},
      }
  );

  const { showNotification } = useLocalNotifications();

  const fetchData = async () => {
      try {
        setLoading(true);

        let resp = []
        //Это данные по доступным fbs
        switch (market) {
          case 'wb': {
            resp = await get("WBAPI/getOpenFbsDealOnCompany", {cid: company_id})
            break
          }
          case 'ozon': {
            resp = await get("OZONAPI/getOpenFbsDealOnCompany", {cid: company_id})
            break
          }
        }
        for (let el of resp) {
          if (el.dealDetails) {
            console.log("ID", el.id)
            el.dealDetails.actions = {
              combined: (e) => {setClickedRow(el.id)}
            }
          }
        }
        setData(resp)

      } catch (err) {
      } finally {
        setLoading(false);
      }
  };

  useEffect(() => {

    fetchData();
  }, [market]); 

  useEffect(() => {
      const getInfo = () => {
          return (
              <>
                  <Typography sx={{ 
                    fontSize: '12pt', 
                    fontWeight: 'bold', 
                    margin: '5px 15px 5px 10px'
                  }}>
                    Количество открытых сделок: {data.length}
                  </Typography>
              </>
          )
      }
      setInfo(getInfo())
  }, [data]);

  useEffect(() => {
      const getButtons = () => {
          return (
            <SelectMarketLocal markets={['wb', 'ozon']} market={market} save={(m) => {localStorage.setItem("FBSMARKET", m); setMarket(m)}} size={30}></SelectMarketLocal>
          )
      }
      setButtons(getButtons())
  }, [market]);

  useEffect(() => {
      const getSearch = () => {
          return (
              <>
                <ClassicSearch 
                  setChecked={setChecked} 
                  setFilter={setFilter} 
                  checked={checked} 
                  // @ts-ignore
                  fields={filterFields} 
                  // @ts-ignore
                  setFields={setFilterFields}
                />
              </>
          )
      }
      setSearch(getSearch())
  }, [checked, setFilter, setChecked]);

    const { socket } = useContext(SocketContext);


  const CloseDeal = (deal) => {
    console.log('CLOSE START')
    const closeDealOk = async (isOk) => {
        if (isOk) {

          try {
            console.log('CLOSE TRY')
            await post("Logs/create", {
                deal_id: deal.id,
                user_type: "ful",
                user_id,
                type: "close_deal",
                data:{}
            });

            socket.emit("dnd_close_deal", {id: deal.id, newStatus: 0, oldType: deal.type, newType: 'archive', company_id});

            let tmp = JSON.parse(JSON.stringify(data)).filter((fel) => fel.id !== deal.id)
            setData(tmp);
            showNotification({
                id: 'SuccessClose', 
                type: 'success', 
                message: 'Сделка завершена' 
            });

        } catch (error) {
            console.error(error);
        }
        }
    }

    if (!deal.FBSstatus || deal.FBSstatus === 'ok') {
      handleConfirm('Вы уверены, что хотите завершить сделку?', closeDealOk);
    }
    else {
      showNotification({
          id: 'DontCanClose', 
          type: 'warning', 
          message: 'Нельзя закрыть сделку, пока она в работе' 
      });
    }

    
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', justifyContent:'flex-start', width: '100%', height: '100%', overflow: 'hidden' }}>
      <Drawer
        anchor='right'
        open={selDeal}
        onClose={() => {setSelDeal(undefined)}}
      >
        <ElementInfo 
          ds={getDataSource("EIDealFBS")} 
          data={selDeal}
          // @ts-ignore
          reload={fetchData}
        />
      </Drawer>
      {!loading && <MoveGuideDialog deal_id={clickedRow} open={clickedRow} onClose={() => {setClickedRow(undefined)}}/>}
      <div style={{
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent:'flex-start', 
          width: '98%', 
          height: "calc(94% - 55px )", 
          overflow: 'hidden',
          margin: "0% 1% 1% 1%",
          borderRadius: "10px",
          backgroundColor: 'white'
      }}>
        {loading? 
          <Loading/>
        :
          <Scrollbars
            style={{ width: '100%', height: "100%", borderRadius: "10px" }} 
            >
              <ReportTable
                ds={ds}
                data={!checked ? data : data.filter((el) => {
                    const tf = filter.toLowerCase(); 
                    return (
                        (filterFields.cdn.active && el.data.cdn && String(el.data.cdn).includes(tf)) || 
                        (filterFields.cli_id.active && el.user.user_id && String(el.user.user_id).includes(tf)) || 
                        (filterFields.cli_name.active && el.user.fio && String(el.user.fio).includes(tf)) || 
                        (filterFields.product.active && el.includes_products.products && el.includes_products.products.map(p => p.title).join("").toLowerCase().includes(tf)) ||
                        (filterFields.barcode.active && el.includes_products.products && el.includes_products.products.map(p => p.barcode).join("").toLowerCase().includes(tf))
                    );
                })}    
                // onClickRow={(cd) => {setSelDeal(cd.id)}}
                aditionalAction={
                  [
                      {
                          action: (item) => { CloseDeal(item) },
                          ui: () => {
                              return (
                                  <HighlightOffIcon 
                                    sx={{
                                      transition: 'all 0.3s ease',
                                      '&:hover': hoverStyle
                                    }
                                  }/>
                              )
                          }
                      }
                  ]
                }
              />               
          </Scrollbars>
        }
        
      </div>
    </div>  
  );
}

const FBSAdminClose = ({setSearch, setInfo, setButtons}) => {

  const { company_id, user_id } = useSelector(
      loginSelector
  );

  const [market, setMarket] = useState(localStorage.getItem("FBSMARKET") || "wb");

  const ds = useMemo(() => {
      let keyword = 'fbsAdminOpen'
      if(market === 'wb') {
        keyword = 'fbsAdminOpenWB'
      }
      const $ds = getDataSource(keyword); 
      $ds.descr.showDetails = (obj) => {
          console.log(obj);
          setSelDeal(obj.id)
      };
      return $ds;
  }, [market]);

  const [loading, setLoading] = useState(true);
  /** @type {[Array<any>, Function]} */
  const [data, setData] = useState([])
  const [selDeal, setSelDeal] = useState(undefined)

  const [checked, setChecked] = useState(false);
  /** @type {[any, Function]} */
  const [filter, setFilter] = useState(null);
  const [filterFields, setFilterFields] = useState(
      {
          cdn: {name: "Номер сделки", active: true},
          cli_id: {name: "ID клиента", active: true},
          cli_name: {name: "Имя клиента", active: true},
          product: {name: "Товар", active: true},
          barcode: {name: "Баркод", active: true},
      }
  );

  useEffect(() => {
    const fetchData = async () => {
        try {
          setLoading(true);

          //Это данные по доступным fbs
          let resp = []
          switch (market) {
            case 'wb': {
              resp = await get("WBAPI/getCloseFbsDealOnCompany", {cid: company_id})
              break
            }
            case 'ozon': {
              resp = await get("OZONAPI/getCloseFbsDealOnCompany", {cid: company_id})
              break
            }
          }
          setData(resp)

        } catch (err) {
        } finally {
          setLoading(false);
        }
    };

    fetchData();
  }, [market]); 

  useEffect(() => {
      const getInfo = () => {
          return (
              <>
                  <Typography sx={{ 
                    fontSize: '12pt', 
                    fontWeight: 'bold', 
                    margin: '5px 15px 5px 10px'
                  }}>
                    Количество закрытых сделок: {data.length}
                  </Typography>
              </>
          )
      }
      setInfo(getInfo())
  }, [data]);

  useEffect(() => {
      const getButtons = () => {
          return (
            <SelectMarketLocal markets={['wb', 'ozon']} market={market} save={(m) => {localStorage.setItem("FBSMARKET", m); setMarket(m)}} size={30}></SelectMarketLocal>
          )
      }
      setButtons(getButtons())
  }, [market]);

  useEffect(() => {
      const getSearch = () => {
          return (
              <>
                <ClassicSearch 
                  setChecked={setChecked} 
                  setFilter={setFilter} 
                  checked={checked} 
                  // @ts-ignore
                  fields={filterFields} 
                  // @ts-ignore
                  setFields={setFilterFields}
                />
              </>
          )
      }
      setSearch(getSearch())
  }, [checked, setFilter, setChecked]);


  

  return (
    <div style={{display: 'flex', flexDirection: 'column', justifyContent:'flex-start', width: '100%', height: '100%', overflow: 'hidden' }}>
      <div style={{
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent:'flex-start', 
          width: '98%', 
          height: "calc(94% - 55px )", 
          overflow: 'hidden',
          margin: "0% 1% 1% 1%",
          borderRadius: "10px",
          backgroundColor: 'white'
      }}>
        {loading? 
          <Loading></Loading>
        :
          <Scrollbars
            autoHeight
            autoHeightMax={"100%"}
            style={{ width: '100%', borderRadius: "10px"}} 
            >
              <ReportTable
                ds={ds}
                data={!checked ? data : data.filter((el) => {
                    const tf = filter.toLowerCase(); 
                    return (
                        (filterFields.cdn.active && el.data.cdn && String(el.data.cdn).includes(tf)) || 
                        (filterFields.cli_id.active && el.user.user_id && String(el.user.user_id).includes(tf)) || 
                        (filterFields.cli_name.active && el.user.fio && String(el.user.fio).includes(tf)) || 
                        (filterFields.product.active && el.includes_products.products && el.includes_products.products.map(p => p.title).join("").toLowerCase().includes(tf)) ||
                        (filterFields.barcode.active && el.includes_products.products && el.includes_products.products.map(p => p.barcode).join("").toLowerCase().includes(tf))
                    );
                })}    
                onClickRow={(cd) => {setSelDeal(cd.id)}}
                
              />               
          </Scrollbars>
        }
        
      </div>
      <Drawer
        anchor='right'
        open={selDeal}
        onClose={() => {setSelDeal(undefined)}}
      >
        <ElementInfo 
          ds={getDataSource("EIDealFBS")} 
          data={selDeal}
        />
      </Drawer>
    </div>  
  );
}

// @ts-ignore
export default function FBSAdmin() {
    const [tab, setTab] = useState(0);
    // @ts-ignore
    // @ts-ignore
    const handleChange = (event, newTab) => {
        setTab(newTab);
    };

    const [info, setInfo] = useState(undefined)
    const [search, setSearch] = useState(undefined)
    const [buttons, setButtons] = useState(undefined)
    
    return (
        <Box sx={{ width: '100%', height: '100%'}}>
          <div style={{ 
              display: "flex", 
              flexDirection: "row", 
              justifyContent: "space-between", 
              alignItems: "center", 
              height: "5%", 
              margin: "10px 1% 10px 1%"
            }}
          >
            {search || <div></div>}

            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    borderRadius: '10px',
                }}>
                    {!info? 
                        <Loading/>
                    :
                        info
                    }
                </Box>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px', marginLeft: "10px"}}>
                    {buttons}
                </div>
            </div>
          </div>
          <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example" sx={{
              "& .MuiTabs-indicator": {
                  display: "none"
              },
              margin: '0% 0% 0% 1%',
              height: "30px",
              minHeight: "30px"
          }}>
              <DealTab label="НОВЫЕ" />
              <DealTab label="ОТКРЫТЫЕ" />
              <DealTab label="ЗАВЕРШЕННЫЕ" />
          </Tabs>
          <TabPanel value={0} select={tab}>
              {<FBSAdminNew setInfo={setInfo} setSearch={setSearch} setButtons={setButtons}/>}
          </TabPanel>
          <TabPanel value={1} select={tab}>
              {<FBSAdminOpen setInfo={setInfo} setSearch={setSearch} setButtons={setButtons}/>}
          </TabPanel>
          <TabPanel value={2} select={tab}>
              {<FBSAdminClose setInfo={setInfo} setSearch={setSearch} setButtons={setButtons}/>}
          </TabPanel>          
      </Box>
    );
}